module.exports = __webpack_public_path__ + "img/workbench_upload2.b7767bde.svg";